<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="attachments-main">
    <Input v-if="!viewMode" textType="file" placeholder="Browse" style="margin-bottom: 5px" @fileChanged="attachmentsChanged" :multiFile="true"
      ref="att" />
    <!-- <Input placeholder="File Name" /> -->
    <Input v-if="!viewMode" placeholder="Remarks" :inputValue.sync="remarks" :errorMessage.sync="remarksErrorMessage" :validator="`text,${remarksLength}`" />

    <div v-if="!viewMode" class="buttons" >
      <button @click="addClicked">Add</button>
      <button @click="delClicked">Delete</button>
    </div>

    <TableBox style="height: calc(100% - 100px)" title="Attachments" :hideColumns="hiddenColumns" :tableData="attachmentData" :maxSelection="-1"
      :selectedRow.sync="selectedAttachments" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      remarks: '',
      remarksErrorMessage: '',
      attachmentList: [],
      attachmentData: [],
      selectedAttachments: [],    

      hiddenColumns: [ 'Attachment', 'ID', '#', 'attachmentaction' ]
    }
  },
  props: {
    attachments: { type: Array, default: function() { return [] } }, // The attachments to load in the table box, use .sync for 2 way binding

    viewMode: { type: Boolean, default: false }, // Set to true if view mode; all inputs and buttons will be disabled

    remarksLength: { type: Number, default: 200 }, // The max length of the remarks field
  },
  methods: {
    addClicked: async function() {
      if (this.attachmentList.length == 0) {
        this.$showAlert('error', 'No File Selected', 'Please select at least one file to add attachment');
      } else { 
        if (this.remarks.length > 200) {
          this.remarksErrorMessage = 'Remarks cannot exceed 200 characters';
          return;
        }
        let newAttachments = [];
        let highestID = 0;
        for (let a of this.attachmentData) {
          if (a['ID'] > highestID) {
            highestID = a['ID'];
          }
        }
        for (let a of this.attachmentList) {
          newAttachments.push({
            attachmentaction : 'N',
            ID : ++highestID,
            FileName : a.name,
            Remarks : this.remarks,
            Attachment : await this.$convertFile.toBase64(a)
          });
        }
        this.$emit('attachmentsAdded', newAttachments);
        
        let temp = this.attachmentData;
        this.attachmentData = [];
        this.$nextTick(() => {
          temp = temp.concat(newAttachments);
          this.attachmentData = temp;
          
          this.$emit('update:attachments', this.attachmentData);
          this.$refs.att.clearAttachmentClicked();
          this.remarks = '';
        });
      }
    },
    delClicked: function() {
      if (this.selectedAttachments.length == 0) {
        this.$showAlert('error', 'No File Selected', 'Please select at least one file from the list below to delete');
      } else {
        this.$emit('attachmentsDeleted', this.selectedAttachments);
        let temp = this.attachmentData;
        this.attachmentData = [];
        this.selectedAttachments.forEach(s => {
          let index = temp.findIndex(d => d['ID'] === s['ID']);
          temp.splice(index, 1);
        });

        this.$nextTick(() => {
          this.attachmentData = temp;
          this.selectedAttachments = [];

          this.$emit('update:attachments', this.attachmentData);
        });
      }
    },
    attachmentsChanged: function(e) {
      this.attachmentList = e;
    },
    attachmentDblClick: async function(attachment) {
      // console.log(attachment);
      // var open = await this.$apiCallV2(`/Supplier/OpenAttachment?fileName=${attachment['File Name']}&base64=${attachment['Attachment']}`);
      // console.log(open.data.split('\\').join('/'));

      // window.open('file:///C:/Users/DSM/Desktop/tmp2.txt', '_blank');
    }
  },
  mounted() {
    if (this.attachments) {
      this.attachmentData = this.attachments;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.attachments-main {
  height: calc(100%);
  width: 100%;
}

.buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 5px;

  > button {
    margin: 3px;
  }
}
</style>